module.exports = __webpack_public_path__ + "fonts/ionicons.0b4ad61.woff";